import { Col, Divider, Row } from 'antd'
import React from 'react'

import { MemberProps } from '../../convention'
import Info from './Info'

type PriceInfoProps = React.ComponentProps<typeof Info>['props']

const QuotePriceSummary: React.FC<MemberProps<IQuote>> = ({ member }) => {
  const hasPaid = Number(member.price_paid) > 0

  const renderInfos = (info: PriceInfoProps[]) =>
    info.map((props) => (
      <Info key={props.attribute} member={member} props={{ className: 'text-sm', ...props }} />
    ))

  return (
    <Row gutter={[12, 0]}>
      <Col span={24}>
        {renderInfos([{ attribute: 'net_total' }, { attribute: 'tax' }, { attribute: 'deposit' }])}
      </Col>
      <If condition={!hasPaid}>
        <Col span={24}>
          <Divider style={{ margin: '12px 0' }} />
        </Col>
        <Col span={24}>{renderInfos([{ attribute: 'gross_total_with_deposit', bold: true }])}</Col>
      </If>
      <If condition={hasPaid}>
        <Col xs={24}>
          <Divider style={{ margin: '12px 0' }} />
        </Col>
        <Col span={24}>
          {renderInfos([{ attribute: 'price_paid' }, { attribute: 'open_amount', bold: true }])}
        </Col>
      </If>
    </Row>
  )
}

export default QuotePriceSummary
